import Lottie from 'react-lottie'
import animationData from '../../../../assets/lotties/magnifyingSpin.json'

interface MagnifyingSpinProps {
  className?: string
  dataQa?: string
}

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
}

export const MagnifyingSpin = ({
  className,
  dataQa = 'magnifying-glass-spin',
}: MagnifyingSpinProps) => (
  <div className={className} data-qa={dataQa}>
    <Lottie
      isClickToPauseDisabled={true}
      options={defaultOptions}
      height={40}
      width={40}
    />
  </div>
)
